import script from "./promotion.vue?vue&type=script&setup=true&lang=js"
export * from "./promotion.vue?vue&type=script&setup=true&lang=js"

import "./promotion.vue?vue&type=style&index=0&id=15d32fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d32fc2"]])

export default __exports__